import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, ViewContainerRef } from '@angular/core';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var MapInfoContainerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MapInfoContainerComponent, _super);
    function MapInfoContainerComponent(_vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.showDescription = true;
        _this.editable = false;
        _this.collapseDescription = true;
        _this.showOptionMenu = true;
        _this.editTitle = false;
        _this._isCompact = false;
        _this.exitCompactViewEvent = new EventEmitter();
        _this.registerEvent('exitCompactView', _this.exitCompactViewEvent);
        return _this;
    }
    Object.defineProperty(MapInfoContainerComponent.prototype, "isCompact", {
        get: function () {
            return this._isCompact;
        },
        set: function (value) {
            this._isCompact = value;
            this.toggleCompactLegend(value);
        },
        enumerable: true,
        configurable: true
    });
    MapInfoContainerComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapInfoContainerComponent.prototype.showHideInfo = function () {
        this.collapseDescription = !this.collapseDescription;
    };
    MapInfoContainerComponent.prototype.toggleEdit = function () {
        this.editTitle = !this.editTitle;
        if (this.editTitle) {
            this.mapName = this.mapViewRef.mapcoreViewProps.name;
        }
    };
    MapInfoContainerComponent.prototype.saveMapName = function () {
        this.editTitle = false;
        this.mapViewRef.mapcoreViewProps.name = this.mapName;
    };
    MapInfoContainerComponent.prototype.toggleCompactLegend = function (isCompact) {
        if (isCompact) {
            this.showDescription = false;
            this.showOptionMenu = false;
        }
        else {
            this.showDescription = true;
            this.showOptionMenu = true;
        }
    };
    MapInfoContainerComponent.prototype.exitCompactView = function () {
        this.exitCompactViewEvent.emit(true);
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], MapInfoContainerComponent.prototype, "editable", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], MapInfoContainerComponent.prototype, "isCompact", null);
    return MapInfoContainerComponent;
}(BaseComponent));
export { MapInfoContainerComponent };
